import type { IconDefinition, IconName, IconPrefix } from "@fortawesome/fontawesome-svg-core";

export const InfoCircleOutline: IconDefinition = {
  prefix: "fac" as IconPrefix,
  iconName: "info-circle-outline" as IconName,
  icon: [
    512,
    512,
    [],
    "",
    // outline ring
    "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z" +
      // dot
      "M224 160a32 32 0 1 1 64 0a32 32 0 1 1-64 0z" +
      // stem
      "M216 224h56c13.3 0 24 10.7 24 24v104h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V272h-32c-13.3 0-24-10.7-24-24s10.7-24 24-24z",
  ],
};
